// extracted by mini-css-extract-plugin
module.exports = {"roleCard":"MntrProfGrid_roleCard__i3keV","back_image":"MntrProfGrid_back_image__17MWR","Back_img":"MntrProfGrid_Back_img__3oe3p"};